import {
  ShieldCheck,
  FileText,
  TrendingUp,
  FolderOpen,
  type LucideIcon,
} from 'lucide-react';
import type { SmartSortingCategory } from '../../../types/api';

export interface CategoryConfig {
  key: SmartSortingCategory;
  label: string;
  icon: LucideIcon;
  color: string;
}

export const SMART_SORTING_CATEGORIES: readonly CategoryConfig[] = [
  {
    key: 'compliance_document',
    label: 'Cumplimiento',
    icon: ShieldCheck,
    color: 'var(--brand-600)',
  },
  {
    key: 'invoices',
    label: 'Facturas',
    icon: FileText,
    color: 'var(--warning-500, #f59e0b)',
  },
  {
    key: 'sales',
    label: 'Ventas',
    icon: TrendingUp,
    color: 'var(--success-600, #22c55e)',
  },
  {
    key: 'other',
    label: 'Otros',
    icon: FolderOpen,
    color: 'var(--text-muted)',
  },
] as const;

export const CATEGORY_ORDER: readonly SmartSortingCategory[] = [
  'compliance_document',
  'invoices',
  'sales',
  'other',
];

export function getCategoryConfig(key: SmartSortingCategory): CategoryConfig {
  return (
    SMART_SORTING_CATEGORIES.find((c) => c.key === key) ??
    SMART_SORTING_CATEGORIES[3]!
  );
}
